const riot = require('riot');

riot.tag2('module-webhook-list', '<div class="s-full rounded-8 elevation-default-low bg-white"> <div class="section-padding"> <div class="mb36" data-is="module-section-header" title="Webhook"></div> <div class="te-psx text-gray_60 mb8">配布イベントをWebhook管理で設定されている複数のWebhookに送信できます。</div> <button class="button size-m" if="{!opts.disabled}" type="button" onclick="{onGoWebhook}">Webhookの追加</button> </div> <div class="f fclm"> <div class="max-height-500" data-is="module-table" schemas="{webhookTableSchemas}" items="{distributionRuleWebhookSettings}" scroll-type="y"></div> <div class="f fr mta mr32"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div>', 'module-webhook-list,[data-is="module-webhook-list"]{display:block}', '', function(opts) {
    const LIMIT = 50;

    this.webhookTableSchemas = [
      {
        id: 'name',
        label: '名前',
        component: 'link',
        getLink: (item) => `${location.pathname}/webhooks/${item.id}`,
      },
      {
        id: 'webhook_endpoint',
        label: 'URL',
      },
      {
        id: 'http_method',
        label: 'メソッド',
      },
      {
        id: 'menu',
        component: 'material-icon-button',
        align: 'center',
        class: 'flex-fixed w48',
        text: 'more_vert',
        onclick: (item, e) => {
          this.onOpenActionSheet(item, e);
        },
        shouldShow: () => {
          return !this.opts.disabled;
        }
      },
    ];

    this.on('mount', async () => {
      var company_id = this.opts.distributionRule.company.id;
      var project_id = this.opts.distributionRule.project.id;

      var query = {
        offset: 0,
        limit: LIMIT,
        distribution_rule_id: this.opts.distributionRule.id,
      };

      var webhook_api = app.api.child(`companies/${company_id}/projects/${project_id}/distribution_rule_webhook_settings`);
      var { distribution_rule_webhook_settings, pagination } = await webhook_api.get(query);

      this.distributionRuleWebhookSettings = distribution_rule_webhook_settings;
      this.pagination = pagination;
      this.webhookApi = webhook_api;
      this.update();

      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.pagination[offset_type];
        var query = {
          offset,
          limit: LIMIT,
          distribution_rule_id: this.opts.distributionRule.id,
        };
        try {
          var { distribution_rule_webhook_settings, pagination } = await this.webhookApi.get(query);
          this.distributionRuleWebhookSettings = distribution_rule_webhook_settings;
          this.pagination = pagination;
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message)
        }
        finally {
          indicator.close();
        }
      });
    })

    this.onOpenActionSheet = (item, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "clipboard-copy",
          label: "テンプレートとして保存",
          action: () => { popup.close(); this.openModalPostTemplate(item); },
        },
        {
          icon: "trash",
          label: "削除",
          action: () => { popup.close(); this.deleteWebhook(item); },
          alert: true
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.openModalPostTemplate = async (item) => {
      var buttons = [
        {
          type: 'button',
          text: 'キャンセル',
          class: 'text',
          onclick: () => modal.close(),
        },
        {
          type: 'submit',
          text: '保存',
          class: 'outline',
        },
      ];

      var modal = await app.utils.openModalInput(
        {
          title: 'Webhookテンプレートとして保存',
          input_lable: 'Webhookテンプレート名',
          required: true,
          buttons,
          size: 'large',
          submit: (v) => this.postTemplate(v, item),
        },
      );
    };

    this.deleteWebhook = async (webhook) => {
      var result = await app.utils.openModalDialog(
        {
          title: 'Webhookの削除',
          text: '本当にこのWebhookを削除しますか？今後このWebhookを利用した送信は行うことができなくなります。この操作は取り消すことができません。',
          size: 'medium',
          danger: true,
          positive: '削除',
        }
      );
      if (!result) return;

      var indicator = spat.modal.indicator();
      try {

        await this.webhookApi.child(webhook.id).del({});

        var { distribution_rule_webhook_settings, pagination } = await this.webhookApi.get({ offset: 0, limit: LIMIT, distribution_rule_id: this.opts.distributionRule.id });
        this.distributionRuleWebhookSettings = distribution_rule_webhook_settings;
        this.pagination = pagination;
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.postTemplate = async (value, item) => {
      var indicator = spat.modal.indicator();

      var query = {
        body_template: item.body_template,
        event_type: item.event_type,
        headers: JSON.parse(item.header_json),
        http_method: item.http_method,
        name: value,
        webhook_endpoint: item.webhook_endpoint,
      };

      var company_id = this.opts.distributionRule.company.id;
      var project_id = this.opts.distributionRule.project.id;

      try {
        var { project_webhook_setting } = await app.api.child(`companies/${company_id}/projects/${project_id}/project_webhook_settings`).post(query);
        spat.toast.message('更新しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onGoWebhook = () => {
      spat.router.push(`${location.pathname}/webhooks/new`);
    };
});